import React from 'react'
import {
  DrawerWrapper,
  DrawerHeader,
  DrawerHeaderLeft,
  DrawerIconBox,
  DrawerTitleGroup,
  DrawerLabel,
  DrawerTitle,
  CloseButton,
  DrawerBody,
  Section,
  SectionTitle,
  SectionBody,
  DetailRowWrapper,
  DetailIconBox,
  DetailContent,
  DetailLabel,
  DetailValue,
} from './AccountDetailsDrawer.styles'
import {
  StyledBuildingIcon,
  StyledCalendarIcon,
  StyledCloseIcon,
  StyledLocIcon,
  StyledMailIcon,
  StyledTelIcon,
} from '../../../../shared/icons/icons.styles'

// Detail Row

function DetailRow({icon, label, value}) {
  return (
    <DetailRowWrapper>
      <DetailIconBox>{icon}</DetailIconBox>
      <DetailContent>
        <DetailLabel>{label}</DetailLabel>
        <DetailValue>{value ?? '—'}</DetailValue>
      </DetailContent>
    </DetailRowWrapper>
  )
}

// Drawer

function AccountDetailsDrawer({account, onClose, isSandboxContext = false}) {
  const memberSinceYear =
    account?.createdAt || account?.accountCreatedAt
      ? new Date(account?.createdAt ?? account?.accountCreatedAt).getFullYear()
      : '—'

  return (
    <DrawerWrapper>
      <DrawerHeader>
        <DrawerHeaderLeft>
          <DrawerIconBox>
            <StyledBuildingIcon />
          </DrawerIconBox>
          <DrawerTitleGroup>
            <DrawerLabel>ACCOUNT DETAILS</DrawerLabel>
            <DrawerTitle>
              {account?.company || account?.companyName}
            </DrawerTitle>
          </DrawerTitleGroup>
        </DrawerHeaderLeft>

        <CloseButton onClick={onClose} aria-label="Close details">
          <StyledCloseIcon />
        </CloseButton>
      </DrawerHeader>

      <DrawerBody>
        <Section>
          <SectionTitle>Business Details</SectionTitle>
          <SectionBody>
            <DetailRow
              icon={<StyledBuildingIcon />}
              label="Business Name"
              value={account?.company || account?.companyName}
            />
            <DetailRow
              icon={<StyledCalendarIcon />}
              label="Member Since"
              value={memberSinceYear}
            />
          </SectionBody>
        </Section>

        <Section>
          <SectionTitle>Contact Information</SectionTitle>
          <SectionBody>
            <DetailRow
              icon={<StyledMailIcon />}
              label="Email Address"
              value={account?.email || account?.accountEmail}
            />
            <DetailRow
              icon={<StyledTelIcon />}
              label="Phone Number"
              value={account?.address?.phone}
            />
          </SectionBody>
        </Section>

        <Section>
          <SectionTitle>
            {isSandboxContext ? 'Sandboxes' : 'Locations'}
          </SectionTitle>
          <SectionBody>
            <DetailRow
              icon={<StyledLocIcon />}
              label={isSandboxContext ? 'Total Sandboxes' : 'Total Locations'}
              value={account?.locations?.length}
            />
          </SectionBody>
        </Section>
      </DrawerBody>
    </DrawerWrapper>
  )
}

export default AccountDetailsDrawer
